import { Link } from "react-router-dom";
import { ArrowLeft } from "lucide-react";

export default function CookiePolicy() {
    return (
        <main data-testid="cookie-page" className="bg-tl-light pb-24 pt-36">
            <div className="mx-auto max-w-3xl px-4 sm:px-6">
                <Link
                    to="/"
                    data-testid="cookie-back-link"
                    className="inline-flex items-center gap-2 font-mono-tl text-xs uppercase tracking-[0.2em] text-tl-mutedDark transition-colors hover:text-tl-orange"
                >
                    <ArrowLeft size={14} /> Torna alla home
                </Link>
                <h1 className="mt-8 font-display text-3xl font-bold tracking-tight text-tl-ink sm:text-4xl">
                    Cookie Policy
                </h1>
                <div className="mt-8 space-y-6 text-sm leading-relaxed text-tl-mutedDark sm:text-base">
                    <p>
                        Questo sito utilizza esclusivamente cookie tecnici necessari al
                        corretto funzionamento delle pagine e della navigazione. Non
                        vengono utilizzati cookie di profilazione propri.
                    </p>
                    <p>
                        La mappa di Google Maps presente nella sezione Contatti è un
                        servizio di terza parte: la sua visualizzazione può comportare
                        l'installazione di cookie da parte di Google secondo le relative
                        informative.
                    </p>
                    <p>
                        Puoi gestire o eliminare i cookie in qualsiasi momento tramite le
                        impostazioni del tuo browser.
                    </p>
                    <p className="border border-tl-ink/15 bg-white p-4 font-mono-tl text-xs uppercase tracking-[0.1em] text-tl-mutedDark">
                        Nota: testo da completare e verificare prima della pubblicazione
                        definitiva.
                    </p>
                </div>
            </div>
        </main>
    );
}
